module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-l-50 m-t-30 w-500"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户名",
      "prop": "username"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.username),
      expression: "form.username",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-200",
    attrs: {
      "maxlength": 32
    },
    domProps: {
      "value": (_vm.form.username)
    },
    on: {
      "input": function($event) {
        _vm.form.username = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "密码",
      "prop": "password"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.password),
      expression: "form.password",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-200",
    domProps: {
      "value": (_vm.form.password)
    },
    on: {
      "input": function($event) {
        _vm.form.password = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "真实姓名",
      "prop": "realname"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.realname),
      expression: "form.realname",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-200",
    domProps: {
      "value": (_vm.form.realname)
    },
    on: {
      "input": function($event) {
        _vm.form.realname = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "部门",
      "prop": "structure_id"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.structure_id),
      expression: "form.structure_id"
    }],
    staticClass: "w-200",
    attrs: {
      "multiple": "",
      "placeholder": "请选择部门"
    },
    domProps: {
      "value": (_vm.form.structure_id)
    },
    on: {
      "input": function($event) {
        _vm.form.structure_id = $event
      }
    }
  }, _vm._l((_vm.orgsOptions), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.title,
        "value": item.id
      }
    })
  }))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "职位",
      "prop": "position"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.position),
      expression: "form.position",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-200",
    domProps: {
      "value": (_vm.form.position)
    },
    on: {
      "input": function($event) {
        _vm.form.position = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号码",
      "prop": "mobile"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.mobile),
      expression: "form.mobile",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-200",
    domProps: {
      "value": (_vm.form.mobile)
    },
    on: {
      "input": function($event) {
        _vm.form.mobile = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邮箱",
      "prop": "email"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.email),
      expression: "form.email",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-200",
    domProps: {
      "value": (_vm.form.email)
    },
    on: {
      "input": function($event) {
        _vm.form.email = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "微信号",
      "prop": "weixin_id"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.weixin_id),
      expression: "form.weixin_id",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-200",
    domProps: {
      "value": (_vm.form.weixin_id)
    },
    on: {
      "input": function($event) {
        _vm.form.weixin_id = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "座机",
      "prop": "telephone"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.telephone),
      expression: "form.telephone",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-200",
    domProps: {
      "value": (_vm.form.telephone)
    },
    on: {
      "input": function($event) {
        _vm.form.telephone = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.remark),
      expression: "form.remark",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-200",
    domProps: {
      "value": (_vm.form.remark)
    },
    on: {
      "input": function($event) {
        _vm.form.remark = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上级",
      "prop": "leader"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.leader),
      expression: "form.leader"
    }],
    staticClass: "w-200",
    attrs: {
      "filterable": "",
      "placeholder": "请选择上级"
    },
    domProps: {
      "value": (_vm.form.leader)
    },
    on: {
      "input": function($event) {
        _vm.form.leader = $event
      }
    }
  }, _vm._l((_vm.users), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.realname,
        "value": item.id
      }
    })
  }))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "用户组"
    }
  }, [_c('el-checkbox-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedGroups),
      expression: "selectedGroups"
    }],
    domProps: {
      "value": (_vm.selectedGroups)
    },
    on: {
      "input": function($event) {
        _vm.selectedGroups = $event
      }
    }
  }, _vm._l((_vm.groupOptions), function(item) {
    return _c('el-checkbox', {
      staticClass: "form-checkbox",
      attrs: {
        "label": item.title
      }
    })
  }))]), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.add()
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.goback()
      }
    }
  }, [_vm._v("返回")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5b7df74d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Administrative/personnel/users/add.vue
// module id = 1875
// module chunks = 2